import useConfig from '../../../config/config.context';
import CaasStorageKeys from '../../../constants/caas.storage.keys';
import EyeClosedIcon from '../../shared/Icons/EyeClosedIcon';
import EyeOpenIcon from '../../shared/Icons/EyeOpenIcon';

export default function BalanceControl() {
  const { config, updateStorage } = useConfig();

  return config[CaasStorageKeys.STORAGE].showBalance ? (
    <EyeOpenIcon
      data-testid="opened-eye-icon"
      onClick={() => {
        updateStorage('showBalance', false);
      }}
    />
  ) : (
    <EyeClosedIcon
      data-testid="closed-eye-icon"
      onClick={() => {
        updateStorage('showBalance', true);
      }}
    />
  );
}
